module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.3e87064b.ttf";